// A booking's rooms on the desk sheets. Up to five, listed as the desk types
// them (« 110, 111, 201, 301 »). From six (§8.8o, operator 2026-09-26 —
// AMIHAN's 30 rooms took six lines of the column): the count, then one line
// per floor with runs of doors as ranges, so the list stays complete on paper
// and the column stays narrow.

import { displayRoom, roomsByFloor, ROOMS_BY_FLOOR_FROM } from './departureSheet.js';

export function RoomList({ rooms }: { rooms: string[] }) {
  const n = new Set(rooms.map(displayRoom)).size;
  if (n < ROOMS_BY_FLOOR_FROM) return <>{rooms.map(displayRoom).join(', ') || '—'}</>;
  return (
    <>
      {n} chambres
      <span className="pms-room-floors">
        {roomsByFloor(rooms).map((f) => (
          <span key={f.floor}>{f.text}</span>
        ))}
      </span>
    </>
  );
}
